import {
  SandTableType,
  type ST,
  type STImage,
  type STMap,
  type STMatrix,
} from '@types';

type Item = ST | undefined | null;

export const isSTMap = (item: Item): item is STMap => {
  if (!item) return false;
  return item.type === SandTableType.map;
};
export const isSTImage = (item: Item): item is STImage => {
  if (!item) return false;
  return item.type === SandTableType.image;
};
export const isSTMatrix = (item: Item): item is STMatrix => {
  if (!item) return false;
  return item.type === SandTableType.matrix;
};
export const isSTImageOrMatrix = (item: Item): item is STImage | STMatrix => {
  if (!item) return false;
  return (
    item.type === SandTableType.image || item.type === SandTableType.matrix
  );
};
